import React from "react";
import { ReturnIdDropdown } from "../ReturnIdDropdown/ReturnIdDropdown";
import type { DestinationReturnIdOption } from "../ReturnIdDropdown/ReturnIdDropdown.types";

interface SelectReturnIdCellProps {
  data?: any;
  onSelectReturnId?: (rowData: any, option: DestinationReturnIdOption | null) => void;
}

export const SelectReturnIdCell: React.FC<SelectReturnIdCellProps> = ({
  data,
  onSelectReturnId,
}) => {
  if (!data) return <></>;

  return (
    <ReturnIdDropdown
      value={data.InternalK1SelectedReturnId || ""}
      clientMasterId={data.ClientMasterId}
      parentClientMasterId={data.ParentClientMasterId}
      onChange={(option) => onSelectReturnId?.(data, option)}
    />
  );
};
